import Stack from '@mui/material/Stack'
import React from 'react'
import { ValueNarrative, ValueNarrativeCategory } from '../../../../queries/useGetValueNarrativesQuery'
import TableView from './components/TableView'

type TableViewTabProps = {
    data: ValueNarrativeCategory[]
    handleSelectNarrative: (categoryId: string, valueNarrativeId: string) => void
    isReorderModeActive?: boolean
    onReorderCategoryNarratives?: (categoryId: string, newNarratives: ValueNarrative[]) => void
}

const TableViewTab = ({
    data,
    handleSelectNarrative,
    isReorderModeActive,
    onReorderCategoryNarratives,
}: TableViewTabProps) => {
    return (
        <Stack gap={1}>
            {data.map((category) => {
                const isCategoryReorderable = !category.narratives.some((narrative) => !!narrative.archived)

                return (
                    <TableView
                        key={category._id}
                        category={category}
                        handleSelectNarrative={handleSelectNarrative}
                        isReorderModeActive={!!isReorderModeActive && isCategoryReorderable}
                        onReorderNarratives={(newNarratives) =>
                            onReorderCategoryNarratives?.(category._id, newNarratives)
                        }
                    />
                )
            })}
        </Stack>
    )
}

export default TableViewTab
